import { IconCat, IconChevronDown } from "@tabler/icons-react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { cn } from "#utils";
import { useNavigate } from "react-router-dom";

function AnimalSelector({ className, animals }) {
  const navigate = useNavigate();
  return (
    <Popover className={cn("relative", className)}>
      <PopoverButton className="inline-flex items-center justify-center py-3 gap-x-1 text-sm/6 font-semibold text-gray-900 dark:text-white hover:bg-gray-100 w-full h-full">
        <span>Animals</span>
        <IconChevronDown aria-hidden="true" className="size-5" />
      </PopoverButton>

      <PopoverPanel
        transition
        className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 bg-transparent px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
      >
        <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm/6 shadow-lg outline-1 outline-gray-900/5 dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
          <div className="p-4">
            {animals.map((animal) => (
              <div
                key={animal.animalId}
                className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50 dark:hover:bg-white/5"
              >
                <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white dark:bg-gray-700/50 dark:group-hover:bg-gray-700">
                  <IconCat
                    aria-hidden="true"
                    className="size-6 text-gray-600 group-hover:text-indigo-600 dark:text-gray-400 dark:group-hover:text-white"
                  />
                </div>
                <div>
                  <button
                    onClick={() => navigate(`/animal/${animal.animalId}`)}
                    className="font-semibold text-gray-900 dark:text-white"
                  >
                    {animal.name} ( {animal.color} {animal.coat} )
                    <span className="absolute inset-0" />
                  </button>
                  <p className="mt-1 text-gray-600 dark:text-gray-400">
                    {animal.notes}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </PopoverPanel>
    </Popover>
  );
}

export default AnimalSelector;
